// Exports
export default {
	"nativeAppBanner": "nativeAppBanner_WCZvu",
	"title": "title_gFB2v"
};
